


// get products
export const getProducts = (products, category, type, limit) => {


  
  const finalProducts = category
    ? products.filter(
        product => product.category.filter(single => single === category)[0]
      )
    : products;

  if (type && type === "new") {
    const newProducts = products.filter(single => single.nuevo);
    const checkpr = products.filter(single => parseInt(single.id) == 113);
    console.log(newProducts)
    return newProducts.slice(0, limit ? limit : newProducts.length);
  }
  if (type && type === "bestSeller") {
    return finalProducts
      .sort((a, b) => {
        return b.saleCount - a.saleCount;
      })
      .slice(0, limit ? limit : finalProducts.length);
  }
  if (type && type === "saleItems") {
    const saleItems = finalProducts.filter(
      single => single.discount && single.discount > 0
    );
    return saleItems.slice(0, limit ? limit : saleItems.length);
  }
  return finalProducts.slice(0, limit ? limit : finalProducts.length);
};

// Minimum order quantity — always 30, everywhere (product page, cart, price math).
export const MIN_QTY = 30;

// get product discount price
export const getPriceForQuantity = (product, quantity) => {
  // Input validation
  if (!product || typeof quantity !== 'number' || quantity < 0) {
    return product.price || 0; // Return safely instead of throwing
  }

  // 30-unit floor: prices are always resolved at (at least) MIN_QTY
  quantity = Math.max(quantity, MIN_QTY);

  // Safety check for prezzi
  if (!product.prezzi || !Array.isArray(product.prezzi) || product.prezzi.length === 0) {
    return product.price || 0;
  }
  
  try {
    // Sort prezzi by min quantity once
    const sortedPrices = [...product.prezzi]
      .sort((a, b) => parseInt(b.min) - parseInt(a.min));
    
    // Find applicable price tier
    const applicablePrice = sortedPrices
      .find(price => parseInt(price.min) <= quantity);
    
    // Get minimum quantity tier for fallback
    const minPriceTier = [...product.prezzi]
      .sort((a, b) => parseInt(a.min) - parseInt(b.min))[0];
    
    // If quantity is less than minimum required, use minimum tier price
    if (quantity < parseInt(minPriceTier.min)) {
      return minPriceTier.price;
    }
    
    // Return the applicable price or fallback
    return applicablePrice ? applicablePrice.price : product.price || 0;
  } catch (error) {
    console.error('Error calculating price:', error);
    return product.price || 0; // Fallback to base price or 0
  }
};



// get product discount price with quantity considerations
export const getDiscountPrice = (price, discount) => {
  return discount && discount > 0 ? price - price * (discount / 100) : null;
};

/* ============================================================
   Print-job pricing — JS port of
   mitralla/models/printjob.py :: MarkingPrintjob.compute_price
   Feed shape (apollo_mitralla enriches it): product.printjobs = [{
     id, teccode, name, pricing_mode, max_colors, quotable,
     cliche_price, cliche_repeat_price, min_job_price, price_per_cm2,
     tiers: [{min_qty, max_qty, price_first_color, price_extra_color, price}]
   }]
   Keep in sync with compute_price. Areas / cm² are out of scope: a
   non-quotable technique returns null and must not enter any total.
   ============================================================ */

const findPrintTier = (printjob, quantity) => {
  const tiers = (printjob && printjob.tiers) || [];
  return (
    tiers.find(
      t =>
        Number(t.min_qty) <= quantity &&
        (!Number(t.max_qty) || quantity <= Number(t.max_qty))
    ) || null
  );
};

// per-unit print price to add on top of the article price; null when not auto-quotable
export const getPrintUnitPrice = (printjob, quantity, colorCount = 1) => {
  if (!printjob || printjob.quotable === false) return null;
  const tier = findPrintTier(printjob, quantity);
  if (!tier) return null;
  if (printjob.pricing_mode === "quantity_color") {
    const c = Math.max(colorCount || 1, 1);
    return (
      Number(tier.price_first_color || 0) +
      Math.max(c - 1, 0) * Number(tier.price_extra_color || 0)
    );
  }
  return Number(tier.price || 0);
};

// one-time setup charge (cliché + trabajo mínimo), independent of quantity
export const getPrintSetupFee = (printjob, colorCount = 1, isRepeat = false) => {
  if (!printjob || printjob.quotable === false) return 0;
  const cliche = isRepeat
    ? Number(printjob.cliche_repeat_price || 0)
    : Number(printjob.cliche_price || 0);
  const minJob = Number(printjob.min_job_price || 0);
  if (printjob.pricing_mode === "quantity_color") {
    const c = Math.max(colorCount || 1, 1);
    return cliche * c + minJob * c;
  }
  return cliche + minJob;
};

// resolve a print selection {teccode, color_count, is_repeat} against a product
export const findPrintjob = (product, teccode) =>
  ((product && product.printjobs) || []).find(pj => pj.teccode === teccode) || null;

// full unit price = article tier price + print per-unit (when a technique is chosen)
export const getUnitPrice = (product, quantity, printSel) => {
  const q = Math.max(Number(quantity) || MIN_QTY, MIN_QTY);
  const article = getPriceForQuantity(product, q) || 0;
  if (!printSel || !printSel.teccode) return article;
  const pj = findPrintjob(product, printSel.teccode);
  const print = getPrintUnitPrice(pj, q, printSel.color_count);
  return article + (print || 0);
};

// per-line one-off setup fee for a chosen print selection
export const getLineSetupFee = (product, printSel) => {
  if (!printSel || !printSel.teccode) return 0;
  const pj = findPrintjob(product, printSel.teccode);
  return getPrintSetupFee(pj, printSel.color_count, printSel.is_repeat);
};

/* Indicative €/kit range for a voice-agent kit (list of feed products).
   "kits" = complete kits: q kits => q units of every product.
   min  = Σ (article tier at q  +  cheapest eligible printjob unit @ 1 colour)
   max  = Σ (article tier at q  +  priciest eligible printjob unit @ max_colors)
   Setup fees are returned separately, not folded into the per-unit range.
   `bands` are {label, qty} — qty is the representative quantity used for the tier
   lookups; label is what the UI shows (e.g. "menos de 500", "hasta 1000"). */
export const KIT_BANDS = [
  { label: "menos de 500", qty: 499 },
  { label: "hasta 500", qty: 500 },
  { label: "hasta 1000", qty: 1000 },
  { label: "hasta 2000", qty: 2000 },
  { label: "hasta 5000", qty: 5000 }
];

// The kit "max" is priced at a realistic colour count, not the technique's absolute
// max (which can be 8 and blows the range up). Capped at this many colours.
export const KIT_RANGE_MAX_COLORS = 3;

export const getKitIndicativeRange = (products = [], bands = KIT_BANDS) => {
  const list = (products || []).filter(Boolean);
  return bands.map(({ label, qty }) => {
    let min = 0;
    let max = 0;
    let setupMin = 0;
    let setupMax = 0;
    list.forEach(product => {
      const article = getPriceForQuantity(product, qty) || 0;
      const jobs = (product.printjobs || []).filter(pj => pj.quotable !== false);
      const unitPrices = jobs
        .map(pj => {
          const hiColors = Math.min(pj.max_colors || 1, KIT_RANGE_MAX_COLORS);
          return {
            low: getPrintUnitPrice(pj, qty, 1),
            high: getPrintUnitPrice(pj, qty, hiColors),
            setup: getPrintSetupFee(pj, hiColors, false)
          };
        })
        .filter(x => x.low != null);
      const printLow = unitPrices.length
        ? Math.min(...unitPrices.map(x => x.low))
        : 0;
      const printHigh = unitPrices.length
        ? Math.max(...unitPrices.map(x => x.high))
        : 0;
      min += article + printLow;
      max += article + printHigh;
      setupMax += unitPrices.length ? Math.max(...unitPrices.map(x => x.setup)) : 0;
    });
    return {
      label,
      qty,
      min: Number(min.toFixed(2)),
      max: Number(max.toFixed(2)),
      setupMin: Number(setupMin.toFixed(2)),
      setupMax: Number(setupMax.toFixed(2))
    };
  });
};

// get product cart quantity
export const getProductCartQuantity = (cartItems, product, color, size) => {
  let productInCart = cartItems.find(
    single =>
      single.id === product.id &&
      (single.selectedProductColor
        ? single.selectedProductColor === color
        : true) &&
      (single.selectedProductSize ? single.selectedProductSize === size : true)
  );
  if (cartItems.length >= 1 && productInCart) {
    if (product.variation) {
      return cartItems.find(
        single =>
          single.id === product.id &&
          single.selectedProductColor === color &&
          single.selectedProductSize === size
      ).quantity;
    } else {
      return cartItems.find(single => product.id === single.id).quantity;
    }
  } else {
    return 0;
  }
};

export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
      .filter(single => single.color === color)[0]
      .size.filter(single => single.name === size)[0].stock;
  }
};

//get products based on category
export const getSortedProducts = (products, sortType, sortValue) => {
  if (products && sortType && sortValue) {
    if (sortType === "category") {
      return products.filter(
        product => product.category.filter(single => single === sortValue)[0]
      );
    }
    if (sortType === "tag") {
      return products.filter(
        product => product.tag.filter(single => single === sortValue)[0]
      );
    }
    if (sortType === "color") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(single => single.color === sortValue)[0]
      );
    }
    if (sortType === "size") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(
            single => single.size.filter(single => single.name === sortValue)[0]
          )[0]
      );
    }
    if (sortType === "filterSort") {
      let sortProducts = [...products];
      if (sortValue === "default") {
        return sortProducts;
      }
      if (sortValue === "priceHighToLow") {
        return sortProducts.sort((a, b) => {
          return b.price - a.price;
        });
      }
      if (sortValue === "priceLowToHigh") {
        return sortProducts.sort((a, b) => {
          return a.price - b.price;
        });
      }
    }
  }
  return products;
};

// get individual element
const getIndividualItemArray = array => {
  let individualItemArray = array.filter(function(v, i, self) {
    return i === self.indexOf(v);
  });
  return individualItemArray;
};

// get individual categories
export const getIndividualCategories = products => {
  let productCategories = [];
  products &&
    products.map(product => {
      return (
        product.category &&
        product.category.map(single => {
          return productCategories.push(single);
        })
      );
    });
  const individualProductCategories = getIndividualItemArray(productCategories);
  return individualProductCategories;
};

// get individual tags
export const getIndividualTags = products => {
  let productTags = [];
  products &&
    products.map(product => {
      return (
        product.tag &&
        product.tag.map(single => {
          return productTags.push(single);
        })
      );
    });
  const individualProductTags = getIndividualItemArray(productTags);
  return individualProductTags;
};

// get individual colors
export const getIndividualColors = products => {
  let productColors = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return productColors.push(single.color);
        })
      );
    });
  const individualProductColors = getIndividualItemArray(productColors);
  return individualProductColors;
};

// get individual sizes
export const getProductsIndividualSizes = products => {
  let productSizes = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return single.size.map(single => {
            return productSizes.push(single.name);
          });
        })
      );
    });
  const individualProductSizes = getIndividualItemArray(productSizes);
  return individualProductSizes;
};

// get product individual sizes
export const getIndividualSizes = product => {
  let productSizes = [];
  product.variation &&
    product.variation.map(singleVariation => {
      return (
        singleVariation.size &&
        singleVariation.size.map(singleSize => {
          return productSizes.push(singleSize.name);
        })
      );
    });
  const individualSizes = getIndividualItemArray(productSizes);
  return individualSizes;
};

export const setActiveSort = e => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const setActiveLayout = e => {
  const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
  gridSwitchBtn.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const toggleShopTopFilter = e => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};
  export const getBrandFromCookie = () => {
    const cookies = document.cookie.split(';');
    const brandCookie = cookies.find(cookie => cookie.trim().startsWith('brand='));
    return 'Creoo';
  };